import { useEffect, useState } from 'react';

/**
 * Updates composer eligibility when a response window expires without a server event.
 * @param endTime - Server-provided response-window deadline.
 * @returns Whether the valid deadline is still in the future.
 */
export const useWhatsAppSessionActive = (endTime?: string | null): boolean => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!endTime) return;
    const remaining = new Date(endTime).getTime() - Date.now();
    if (!Number.isFinite(remaining) || remaining <= 0) return;
    const timer = window.setTimeout(
      () => setTick((tick) => tick + 1),
      Math.min(remaining + 1, 2_147_483_647)
    );
    return () => window.clearTimeout(timer);
  }, [endTime, tick]);
  return Boolean(endTime) && new Date(endTime ?? '').getTime() > Date.now();
};
